import { environment } from '../environments/environment';

export const HOST: string = environment.apiUrl;

//CAMBIAR CONTRASEÑA
export const CAMBIAR_CONTRASENA: string = "cambiarContrasena";
//MODULO DIRECTORIO
export const TODAS_FUENTES: string = "AllFuentes";
export const FUENTE_ID: string = "fuente/id/";
export const FUENTE_EDITAR: string = "editarFuenteDesdeEditarFuente/";
export const FUENTES_POR_OPERACION: string = "fuentesbyoper/";
export const VERIFICAR_CONDIGO_ENTIDAD: string = "existecodigofuente/";
export const FUENTE_ULTIMA_EDICION: string = "ultimaedicion/";
export const ACTIVAR_INACTIVAR_FUENTE: string = "activarinactivarfuente";
//MODULO USUARIOS
export const CONSECUTIVO_USUARIO: string = "usuario/consecutivo";
export const NUEVO_USUARIO_DANE: string = "usuario/nuevousuariodane";
export const CAMBIAR_ESTADO_USUARIO: string = "usuario/cambiarestadousuario";
export const CAMBIAR_ESTADO_USUARIO2: string = "usuario/cambiarestadousuario2/";
export const DESCARGAR_EXCEL_USUARIOS: string = "usuario/generarexccelusuarios";
//MODULO PARAMETRICAS VARIABLES
//MODULO CALENDARIO
//MODULO ANALISIS
export const ANIOS_CALENDARIO_CHV: string = "vigenciascontroller/listaAniosChv";
export const ANIOS_CALENDARIO_FIVI: string = "vigenciascontroller/listaAniosFivi";
export const PERIODO_ACTIVO_CHV: string = "periodoactivochv";
export const PERIODO_ACTIVO_FIVI: string = "periodoactivofivi";
export const ESTADOS_PARA_PERIODO_CHV: string = "estadosinforfteporperiodochv/";
export const FICHA_ANALISIS_GENERAL_CHV: string = "fichaAnalisisGeneralChv/";
export const FICHA_ANALISIS_INDIVIDUAL_CHV: string = "fichaAnalisisIndividualChv/";
export const PERIODO_POR_ANIO_MES_FIVI: string = "periodoFiviporAnioMes/";
export const FICHA_ANALISIS_MENSUAL_GENERAL_FIVI: string = "fichaAnalisisMensualGeneralFivi/";
export const FICHA_ANALISIS_MENSUAL_INDIVIDUAL_FIVI: string = "fichaAnalisisMensualIndividualFivi/";
export const FICHA_ANALISIS_TRIMESTRAL_GENERAL_FIVI: string = "fichaAnalisisTrimestralGeneralFivi/";
export const FICHA_ANALISIS_TRIMESTRAL_INDIVIDUAL_FIVI: string = "fichaAnalisisTrimestralIndividualFivi/";
//MODULO ADMINISTRACION INFORMACION
export const ESTADO_INFORMACION_PERIODO_ACTIVO_CHV: string = "listestainfoadmininfperiodoactchv";
export const CONSULTAR_BASE_HISTORICA_PERIODO_CHV: string = "consultabasehistoricachv";
export const CONSULTAR_BASE_HISTORICA_PERIODO_FIVI: string = "consultaBaseHistoricaFivi";
//MODULO CONTROL OPERATIVO
export const CONTROL_OPERATIVO_CHV: string = "controlOperativoChv/";
export const CONTROL_OPERATIVO_MENSUAL_FIVI: string = "controlOperativoFivi/mensual/";
export const CONTROL_OPERATIVO_TRIMESTRAL_FIVI: string = "controlOperativoFivi/trimestral/";
//MODULO INDICADORES
export const INDICADORES_CHV: string = "informacionindicadoreschv/";
export const INDICADORES_CALENDARIO_TRIMESTRES_FIVI: string = "calendariotrimestresfivi";
export const INDICADORES_TRIMESTRAL_FIVI: string = "informacionindicadoresfivi/";
export const INDICADORES_MENSUAL_FIVI: string = "informacionindicadoresmensaulesfivi/";
//MODULO CUADROS DE SALIDA
export const CUADROS_SALIDA: string = "cuadrosSalida";
export const CUADROS_CHV: string = "/carterahv";
export const CUADROS_FIVI: string = "/financiacion";
export const VERIFICAR_ICOCED: string = "/verificaricoced";
export const GUARDAR_ICOCED: string = "/agregaricoced/";

//CARATULA
//CARGUE MASIVO
export const VERIFICAR_SI_FUENTE_CHV_PUEDE_REPORTAR_PERIODO: string = "validarSiFuenteChvPuedeReportarEnPeriodo/"
export const VERIFICAR_SI_FUENTE_FIVI_PUEDE_REPORTAR_PERIODO: string = "validarSiFuenteFiviPuedeReportarEnPeriodo/"
//NOVEDADES
export const CONSULTAR_NOVEDAD_PERIODO = "consultarNovedadReportada/";
//CONSULTA REPORTES
